export const example1 = [
    { label: 'Faible danger', color: '#99ff66' },
    { label: 'Danger modéré', color: '#ffff66' },
    { label: 'Danger élevé', color: '#ff9933' },
    { label: 'Danger très élevé', color: '#ff3333' },
    { label: 'Extrême', color: '#cc0000' },
    { label: 'Danger très extrême', color: '#660000' },
  ]

  export const example2 = [
    { label: 'Très faible danger', color: '#99ff66' },
    { label: 'Faible danger', color: '#ffff66' },
    { label: 'Danger modéré', color: '#ff9933' },
    { label: 'Haut danger', color: '#ff0000' },
    { label: 'Très haut danger', color: '#990000' },
    { label: 'Danger extrême', color: '#660000' }
];
export const example3 = [
    { label: 'Très faible', color: '#99ff66' },
    { label: 'Faible ', color: '#ffff66' },
    { label: 'Modéré', color: '#ff9933' },
    { label: 'Haut', color: '#ff0000' },
    { label: 'Très haut', color: '#990000' },
    { label: 'Extrême', color: '#660000' }
];
export const example4 = [
    { label: 'Très faible rang (< 80)', color: '#99ff66' },
    { label: 'Faible rang (80 .. 90)', color: '#ffff66' },
    { label: 'Rang modéré (90 .. 95)', color: '#ff9933' },
    { label: 'Haut rang (95 .. 98)', color: '#ff0000' },
    { label: 'Très haut rang (98 .. 99)', color: '#990000' },
    { label: 'Rang extrême (99 .. 100)', color: '#660000' }
];
export const example5 = [
    { label: 'Faible', color: '#99ff66' },
    { label: 'Modéré', color: '#ffff66' },
    { label: 'Élevé', color: '#ff9933' },
    { label: 'Très élevé', color: '#ff3333' },
    { label: 'Extrême', color: '#cc0000' },
    { label: 'Très extrême', color: '#660000' },
  ]
  export const example6 = [
    { label: 'Très faible rang (< 75)', color: '#99ff66' },
    { label: 'Faible rang (75 .. 85)', color: '#ffff66' },
    { label: 'Rang modéré (85 .. 90)', color: '#ff9933' },
    { label: 'Haut rang (90 .. 95)', color: '#ff0000' },
    { label: 'Très haut rang (95 .. 98)', color: '#990000' },
    { label: 'Rang extrême (98 .. 100)', color: '#660000' }
];  